import { Component, OnInit } from '@angular/core';
import { TeamViewModel } from 'src/app/scouting/models/TeamModels';
import { PlayerService } from '../../player.service';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { DatePipe } from '@angular/common';
import { MatDivider } from '@angular/material/divider';
import { MatLine } from '@angular/material/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-select-multiple-playerorg-dialog',
    templateUrl: './select-multiple-playerorg-dialog.component.html',
    styleUrls: ['./select-multiple-playerorg-dialog.component.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatSelectionList, MatDivider, MatListOption, MatLine, MatDialogActions, MatButton, MatDialogClose, DatePipe]
})
export class SelectMultiplePlayerorgDialogComponent implements OnInit {

  teams: TeamViewModel[];
  constructor(private playerSrv: PlayerService) { }

  ngOnInit(): void {
    this.playerSrv.getAllPlayersInTeamsForCurrentSeason().subscribe(teams=>{
      this.teams = teams;
      //console.log(teams);
    });

  }


}
